<template>
  <f7-row class="wd-100">
    <f7-col width="40">
      <f7-link class="wd-100 h-130 m-t-10 no-ripple" @click="$emit('galeria')">
        <div class="wd-100 h-130" :style="`background-image: url('//madai.mx/assets/images/${storage.carrito[idx].image}'); background-position: center; background-repeat: no-repeat; background-size: cover;`" />
      </f7-link>
      <f7-button href="/argolla/" outline small>Ver Otros</f7-button>
    </f7-col>
    <f7-col width="60">
      <template v-if="storage.carrito[idx].medida !== '' && storage.carrito[idx].medida !== undefined">
        <img src="assets/img/otros/check.png" alt="" width="24" style="position: absolute; right: 15px; top: 10px;">
      </template>
      <template v-else>
        <img src="assets/img/otros/warning.png" alt="" width="20" style="position: absolute; right: 15px; top: 10px;">
      </template>
      <span class="d-block text-uppercase bold text-dark">{{ storage.carrito[idx].name }}</span>
      <span class="favorite-icon">
        <f7-link @click="eliminarCarrito()">
          <f7-icon class="favorite-color" md="material:delete_forever"></f7-icon>
        </f7-link>
      </span>
      <span class="d-block text-uppercase fs-10 bold">
        Argolla
      </span>
      <div class="m-t-5">
        <template v-if="promo.tipo">
          <span class="strike fs-12">
            {{ $helper.str.formatearMoneda(storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra !== '' ? storage.carrito[idx].price * 2 : storage.carrito[idx].price) }}
          </span>
          <f7-badge class="d-inline text-uppercase bold h-20 float-right" color="white" style="color: #41ad49; border: 1px solid #41ad49">
            <template v-if="promo.tipo === '3x2'">
              Promoción 3 x 2
            </template>
            <template v-else-if="promo.tipo === '2x1/2'">
              Promoción 2 x 1/2
            </template>
            <template v-else-if="promo.tipo === 'porcentaje'">
              {{ promo.porcentaje }}% de Descuento
            </template>
          </f7-badge>
        </template>
        <div class="bold text-color-madai m-r-10">
          <template v-if="promo.tipo">
            {{ $helper.str.formatearMoneda(promo.price) }}
          </template>
          <template v-else>
            {{ $helper.str.formatearMoneda(storage.carrito[idx].price) }}
          </template>
          <span class="fs-10 p-t-20">IVA INCLUIDO</span>
        </div>
      </div>
      <hr>
      <f7-row class="wd-100">
        <div class="bold fs-13 alert alert-info p-10 m-b-5 wd-100 text-center">
          <f7-link class="no-ripple" href="/ayuda-medida/">
            <span class="m-r-10 text-white">¿Cómo elijo mi medida?</span>
            <f7-icon md="material:help_outline" color="white" size="21"></f7-icon>
          </f7-link>
        </div>
      </f7-row>
      <f7-row>
        <f7-col width="50">
          <select class="select-border"
            :class="{ 'select-border-error': storage.carrito[idx].medida === '' || storage.carrito[idx].medida === undefined }"
            @change="seleccionarMedida($event)"
            style="font-size: 13px; color: #000; font-weight: 500; padding-left: 10px;"
          >
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === ''" value="">MEDIDA</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '3'" value="3">MEDIDA 3</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '3.5'" value="3.5">MEDIDA 3.5</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '4'" value="4">MEDIDA 4</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '4.5'" value="4.5">MEDIDA 4.5</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '5'" value="5">MEDIDA 5</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '5.5'" value="5.5">MEDIDA 5.5</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '6'" value="6">MEDIDA 6</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '6.5'" value="6.5">MEDIDA 6.5</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '7'" value="7">MEDIDA 7</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '7.5'" value="7.5">MEDIDA 7.5</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '8'" value="8">MEDIDA 8</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '8.5'" value="8.5">MEDIDA 8.5</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '9'" value="9">MEDIDA 9</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '9.5'" value="9.5">MEDIDA 9.5</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '10'" value="10">MEDIDA 10</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '10.5'" value="10.5">MEDIDA 10.5</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '11'" value="11">MEDIDA 11</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '11.5'" value="11.5">MEDIDA 11.5</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '12'" value="12">MEDIDA 12</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '12.5'" value="12.5">MEDIDA 12.5</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '13'" value="13">MEDIDA 13</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '13.5'" value="13.5">MEDIDA 13.5</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '14'" value="14">MEDIDA 14</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '14.5'" value="14.5">MEDIDA 14.5</option>
            <option :selected="storage.carrito[idx].medida && storage.carrito[idx].medida === '15'" value="15">MEDIDA 15</option>
          </select>
        </f7-col>
        <f7-col width="50">
          <select class="select-border" @change="seleccionarMedidaExtra($event)" style="font-size: 13px; color: #000; font-weight: 500; padding-left: 10px;">
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === ''" value="">AGREGA PAR</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '3'" value="3">MEDIDA 3</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '3.5'" value="3.5">MEDIDA 3.5</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '4'" value="4">MEDIDA 4</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '4.5'" value="4.5">MEDIDA 4.5</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '5'" value="5">MEDIDA 5</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '5.5'" value="5.5">MEDIDA 5.5</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '6'" value="6">MEDIDA 6</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '6.5'" value="6.5">MEDIDA 6.5</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '7'" value="7">MEDIDA 7</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '7.5'" value="7.5">MEDIDA 7.5</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '8'" value="8">MEDIDA 8</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '8.5'" value="8.5">MEDIDA 8.5</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '9'" value="9">MEDIDA 9</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '9.5'" value="9.5">MEDIDA 9.5</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '10'" value="10">MEDIDA 10</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '10.5'" value="10.5">MEDIDA 10.5</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '11'" value="11">MEDIDA 11</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '11.5'" value="11.5">MEDIDA 11.5</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '12'" value="12">MEDIDA 12</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '12.5'" value="12.5">MEDIDA 12.5</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '13'" value="13">MEDIDA 13</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '13.5'" value="13.5">MEDIDA 13.5</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '14'" value="14">MEDIDA 14</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '14.5'" value="14.5">MEDIDA 14.5</option>
            <option :selected="storage.carrito[idx].medidaExtra && storage.carrito[idx].medidaExtra === '15'" value="15">MEDIDA 15</option>
          </select>
        </f7-col>
      </f7-row>
      <hr class="m-b-0">
      <f7-col>
        <f7-list no-hairlines-md class="m-t-0 m-b-0 no-padding bold">
          <f7-list-item
            class="fs-14"
            title="Agregar grabado"
          >
            <f7-toggle
              slot="after"
              :value="storage.carrito[idx].grabado"
              @toggle:change="grabado($event)"
              :checked="storage.carrito[idx].grabado === 'grabado'"
            ></f7-toggle>
          </f7-list-item>
        </f7-list>
      </f7-col>
    </f7-col>
    <f7-row class="wd-100" v-if="storage.carrito[idx].grabado === 'grabado'">
      <f7-col>
        <f7-list no-hairlines-md class="no-padding m-t-5 m-b-5">
          <template v-if="storage.carrito[idx].medida !== undefined">
            <f7-list-input
              v-if="storage.carrito[idx].medida !== ''"
              :label="`Grabado de Argolla ${storage.carrito[idx].medida ? '( medida ' + storage.carrito[idx].medida + ' )' : ''}`"
              type="text"
              placeholder="Máximo 20 caracteres"
              maxlength="20"
              :value="storage.carrito[idx].grabado1"
              @input="actualizarGrabado($event.target.value, 1)"
            ></f7-list-input>
          </template>
          <template v-if="storage.carrito[idx].medida !== undefined && storage.carrito[idx].medidaExtra !== undefined">
            <f7-list-input
              v-if="storage.carrito[idx].medida !== '' && storage.carrito[idx].medidaExtra !== ''"
              :label="`Grabado de Argolla ${storage.carrito[idx].medidaExtra ? '( medida ' + storage.carrito[idx].medidaExtra + ' )' : ''}`"
              type="text"
              placeholder="Máximo 20 caracteres"
              maxlength="20"
              :value="storage.carrito[idx].grabado2"
              @input="actualizarGrabado($event.target.value, 2)"
            ></f7-list-input>
          </template>
          <f7-list-item v-if="storage.carrito[idx].medida === '' || storage.carrito[idx].medida === undefined">
            <div class="alert alert-warning wd-100 text-center">Debes seleccionar una medida primero</div>
          </f7-list-item>
        </f7-list>
      </f7-col>
    </f7-row>
  </f7-row>
</template>

<script>
export default {
  props: ['idx', 'promocion'],
  computed: {
    promo () {
      let itm = this.storage.carrito[this.idx]
      return this.promocion.find(item => itm.cve === item.cve) || {}
    }
  },
  methods: {
    eliminarCarrito () {
      let itm = this.storage.carrito[this.idx]
      this.storage.carrito = this.storage.carrito.filter(item => item.cve !== itm.cve)
      this.$emit('validar')
    },
    seleccionarMedida (evt) {
      let itm = this.storage.carrito[this.idx]
      this.storage.carrito = this.storage.carrito.map((item, idx) => {
        if (item.cve === itm.cve) {
          item.medida = evt.target.value
        }
        return item
      })
    },
    seleccionarMedidaExtra (evt) {
      let itm = this.storage.carrito[this.idx]
      this.storage.carrito = this.storage.carrito.map((item, idx) => {
        if (item.cve === itm.cve) {
          item.medidaExtra = evt.target.value
        }
        return item
      })
    },
    grabado (event) {
      let itm = this.storage.carrito[this.idx]
      this.storage.carrito = this.storage.carrito.map((item, idx) => {
        if (item.cve === itm.cve) {
          if (item.hasOwnProperty('grabado')) {
            item.grabado = itm.grabado === 'grabado' ? 'sin grabar' : 'grabado'
          } else {
            item.grabado = 'grabado'
            item.grabado1 = ''
            item.grabado2 = ''
          }

          if (item.grabado === 'sin grabar') {
            item.grabado1 = ''
            item.grabado2 = ''
          }
        }
        return item
      })
    },
    actualizarGrabado (value, type) {
      let itm = this.storage.carrito[this.idx]
      this.storage.carrito = this.storage.carrito.map((item, idx) => {
        if (item.cve === itm.cve) {
          if (type === 1) {
            item.grabado1 = value
          } else {
            item.grabado2 = value
          }
        }
        return item
      })
    }
  }
}
</script>
